import(/* webpackMode: "eager" */ "/Users/andrejkazimov/Developer/Forecast/apps/miniapp/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AgreementGate"] */ "/Users/andrejkazimov/Developer/Forecast/apps/miniapp/src/components/AgreementGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BottomNav"] */ "/Users/andrejkazimov/Developer/Forecast/apps/miniapp/src/components/BottomNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/Users/andrejkazimov/Developer/Forecast/apps/miniapp/src/components/PostHogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TonConnectProvider"] */ "/Users/andrejkazimov/Developer/Forecast/apps/miniapp/src/components/TonConnectProvider.tsx");
